export enum DashboardStatisticsPeriodEnum {
  ThisYear = 'thisYear',
  Last365Days = '365',
  Last180Days = '180',
  Last120Days = '120',
  Last30Days = '30',
  Last7Days = '7',
}
